<script setup lang="ts">
import { computed } from "vue"
import { Position, Handle } from "@vue-flow/core"
import type { NodeProps } from "@vue-flow/core"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faShield, faBan, faTriangleExclamation, faClone } from "@fortawesome/pro-regular-svg-icons"
import { buildComponentClasses, buildTooltipMessage, getStepColors } from "@/composables/stepStyles"

library.add(faShield, faBan, faTriangleExclamation, faClone)

const props = defineProps<NodeProps>()

// we will integrate a little more logic here to set border color and icons based on node data
const stepStyle = computed(() => getStepColors(props.data.status))
const errorMessage = computed(() => buildTooltipMessage(props.data?.errors))
const componentClasses = computed(() => buildComponentClasses(props.data.isSelected, stepStyle.value))
</script>

<template>
	<div
		v-if="stepStyle.icons.length > 0"
		v-tooltip="{
			value: errorMessage,
			escape: false,
			pt: {
				arrow: [stepStyle.border.right.primary, stepStyle.border.left.primary],
				text: stepStyle.background.primary,
			},
		}"
		class="absolute -top-4 -right-4 cursor-pointer"
	>
		<FontAwesomeIcon
			v-for="icon in stepStyle.icons"
			:key="icon"
			:icon="['far', icon]"
			class="w-4 h-4 p-1 border-2 rounded-full"
			:class="componentClasses.iconClasses"
		/>
	</div>
	<div v-if="data.isFromTemplate" class="absolute -top-4 -left-4" v-tooltip="`Original: ${data.templateSourceStepName ?? 'Unknown'}`">
		<FontAwesomeIcon :icon="['far', 'clone']" class="w-3 h-3 p-1 border border-blue-400 rounded-full bg-blue-50 text-blue-500" />
	</div>
	<div
		v-tooltip="props.data.tooltip"
		class="text-center w-full h-full rounded-md border border-solid py-2 cursor-pointer"
		:class="componentClasses.divClasses"
	>
		<!-- The node connection point for input  -->
		<Handle v-if="data.isTarget" type="target" :position="Position.Top" />
		<span class="flex items-center justify-center w-full h-full">{{ data.label }}</span>
		<!-- The node connection point for output -->
		<Handle v-if="data.isSource" type="source" :position="Position.Bottom" />
	</div>
</template>
